import React, { useEffect } from 'react'
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import { Link } from 'react-router-dom';
import Skeleton from 'components/shared/Skeleton';
import styles from 'modules/discovery/pages/Home/HashtagCollection/HashtagCollection.module.scss'
import clsx from 'clsx';
import useGetIndexByQuery from 'sdk/hooks/search/useGetIndexByQuery';
import SearchBlock from './SerachBlock';

type Props = {
  search: string,
  selectedCategory?: string,
  setNotFound?: (state: boolean) => void,
}

export default function Hashtags({ search, selectedCategory, setNotFound }: Props) {
  const {
    mutate: getIndex,
    isLoading: loading,
    data,
  } = useGetIndexByQuery()

  useEffect(() => {
    if (search !== undefined) {
      getIndex({
        query: search, index: 'hashtags', category: selectedCategory === 'All' ? '' : selectedCategory,
      })
    }
  }, [search, selectedCategory])

  useEffect(() => {
    if (setNotFound) {
      if (!loading && !data?.length) {
        setNotFound(true)
      } else {
        setNotFound(false)
      }
    }
  }, [loading, data?.length])

  // @ts-ignore
  if (loading && !data?.length) {
    return (
      <SearchBlock title="Hashtags">
        <ScrollingCarousel className={styles.topics}>
          {Array.from(Array(6).keys()).map((item) => (
            <Skeleton className={clsx(styles.listItem, styles.listItemSkeleton)} key={item} />
          ))}
        </ScrollingCarousel>
      </SearchBlock>
    )
  }

  if (!data?.length) {
    return null
  }
  return (
    <SearchBlock title="Hastags" className={loading ? 'blockLoading' : ''}>
      <ScrollingCarousel className={styles.topics}>
        {data?.map((hashtag: any) => (
          <Link
            to={`/hashtags/${hashtag?.objectID}`}
            key={hashtag?.objectID}
            className={styles.listItem}
            style={{ '--hashtag-bg-color': hashtag?.color || `#${Math.floor(Math.random() * 16777215).toString(16)}` } as React.CSSProperties}
          >
            {hashtag.label}
          </Link>
        ))}
      </ScrollingCarousel>
    </SearchBlock>
  )
}
